import Footer from '@efex-components/footer';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import GlobalLoader from '@/components/common/GlobalLoader/GlobalLoader';
import Navbar from '../components/navbar/Navbar';
import ProtectedRoute from '../components/protectedRoutes/ProtectedRoutes';
import Sidebar from '../components/sidebar/Sidebar';
import useIsLogged from '../hooks/useIsLogged';
import useReturnUrl from '../hooks/useReturnUrl';
import SessionTimeout from '../modules/SessionTimeout';
import AuthInitializer from '../modules/auth/AuthInitializer';
import Tour from '../pages/dashboard/components/tour';
import FloatingButtons from './floatingButtons';
import { selectAuthState } from './login/auth/selectors';

const MainLayout = () => {
  const isUserLogged = useIsLogged();
  const location = useLocation();
  const { hydrationCompleted } = useSelector(selectAuthState);

  const { setReturnUrl } = useReturnUrl();

  if (!hydrationCompleted) {
    return <GlobalLoader />;
  }

  if (!isUserLogged) {
    const currentPath = location.pathname + location.search;
    setReturnUrl(currentPath);

    return <Navigate to="/login" replace />;
  }

  if (location.pathname === '/') {
    return <Navigate to="/login" replace />;
  }

  const isUserInactiveView = location.pathname === '/inactive';
  const isRequestTermsView = location.pathname === '/terms-and-conditions';
  const hasTransactionalProfileView =
    location.pathname === '/transactional-profile';
  const isCreatePaymentLinkView = location.pathname === '/create-payment-link';
  const isAccountInValidation = location.pathname === '/validate-account';
  const isAddTeamMemberView = location.pathname === '/add-team-member';

  const isNavigationDisabledView =
    isUserInactiveView || isRequestTermsView || hasTransactionalProfileView;

  const isNoNavBarView =
    isAccountInValidation || isCreatePaymentLinkView || isAddTeamMemberView;

  return (
    <ProtectedRoute>
      {isNavigationDisabledView && (
        <>
          <SessionTimeout />
          <AuthInitializer>
            <div>
              <Navbar />
              <section>
                <Outlet />
              </section>
            </div>
          </AuthInitializer>
        </>
      )}
      {isNoNavBarView && (
        <AuthInitializer>
          <Outlet />
        </AuthInitializer>
      )}
      {!isNoNavBarView && !isNavigationDisabledView && (
        <>
          <SessionTimeout />
          <AuthInitializer>
            <FloatingButtons />
            <Sidebar />
            <div className="pl-[280px] overflow-x-hidden max-lg:pl-0 max-lg:w-screen">
              <Navbar />
              <Tour />
              <div className="bg-[#fbfcff] transition-all duration-500 ease-in-out max-lg:p-0 max-lg:relative max-lg:bg-bodyBg max-lg:z-[99]">
                <Outlet />
                <Footer />
              </div>
            </div>
          </AuthInitializer>
        </>
      )}
    </ProtectedRoute>
  );
};

export default MainLayout;
